import { render, staticRenderFns } from "./adminScriptsMenu.vue?vue&type=template&id=55b38750&scoped=true"
import script from "./adminScriptsMenu.vue?vue&type=script&lang=js"
export * from "./adminScriptsMenu.vue?vue&type=script&lang=js"
import style0 from "./adminScriptsMenu.vue?vue&type=style&index=0&id=55b38750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b38750",
  null
  
)

export default component.exports